const NAME = "SOCIAL_BLACKLIST";

export default NAME;
